import React from 'react';
import ArrowRightRounded from '@material-ui/icons/ArrowRightRounded';

import styles from './styles';
import { withResizer, withTranslations } from '../../HoCs';
import { guc } from '../../services/Localisation';
import Component from '../../ui-components/Component';
import OyoLogo from '../../resources/vectors/oyo';
import { merge } from '../../utils';
import view from '../../Enums';
import { Link } from 'react-router-dom';

class OyoSaathi extends Component {

    styles = styles;

    getIframeHeight = () => this.getViewMode() == view.DESKTOP ? '100%' : '1380';

    render = () => {
        const xsDevice = this.getWidth() < 400;

        return <div style={this.gs('container')}>
            <div style={this.gs('header')}>
                <div style={this.gs('oyo_logo')}>
                    <OyoLogo color='white'  />
                    <div style={this.gs('back_link')}>
                        <Link to='/'>{guc('back_to_partner_page')}</Link>
                        <ArrowRightRounded style={this.gs('back_link_arrow')} />
                    </div>
                </div>
                <div style={merge(this.gs('header_text'), xsDevice && this.gs('header_text_small'))}>
                    {guc('the_worlds_fastest')}
                </div>
            </div>
            <div style={this.gs('content')}>
                <div style={this.gs('left')}>
                    <div style={{ padding: 16, fontSize: 24, fontWeight: 600 }}>{guc('OYO_saathi')}</div>
                    <div style={{ padding: 16 }}>{guc('oyo_saathi_para_1')}</div>
                    <div style={{ padding: 16, fontWeight: 'bold' }}>{guc('how_do_oyo_saathis_earn')}</div>
                    <div style={{ padding: 16 }}>{guc('oyo_saathi_para_2')}</div>
                </div>
                <div style={this.gs('right')}>
                    <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSeuUCdPnQN9KFfAdGtuK5pMViwNidzFdAyf1dFzCZWyicOvRg/viewform?embedded=true" width="100%" height={this.getIframeHeight()} frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
                </div>
            </div>
        </div>;
    }

}

export default withTranslations(withResizer(OyoSaathi));
